import React, {useEffect, useState} from 'react';
import {Dialog, DialogBackdrop, DialogPanel, DialogTitle} from "@headlessui/react";
import Button from "../../../components/button";
import {CopyToClipboard} from "react-copy-to-clipboard/src";
import licensesService from "../../../services/licenses-service";

const LicensesModal = ({open, setOpen, hash, hardwareId}) => {
    const [text, setText] = useState("");
    const [showButtons, setShowButtons] = useState(true);

    useEffect(() => setText(hash), [hash]);

    const verifyLicense = () => {
        licensesService.verifyLicense(hardwareId).then(({data}) => {
            setText(data);
            setShowButtons(false);
        });
    }

    return (
        <Dialog open={open} onClose={setOpen} className="relative z-10">
            <DialogBackdrop
                transition
                className="fixed inset-0 bg-gray-700 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
            />

            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                    <DialogPanel
                        transition
                        className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 max-w-3xl data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
                    >
                        <div className="bg-white py-4 border-b border-gray-300">
                            <div className="sm:flex sm:items-start">
                                <div className="text-left">
                                    <DialogTitle as="h3" className="text-base font-semibold leading-6 text-gray-900 border-b border-gray-300 px-3">
                                        JSON Retorno
                                    </DialogTitle>
                                    <div className="mt-4 px-3">
                                        <p className="text-sm text-gray-500 break-all">
                                            {text}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="flex justify-end gap-3 p-3">
                            {
                                showButtons &&
                                <>
                                    <Button target="primary" onClick={verifyLicense}>
                                        Verificar Hardware ID
                                    </Button>
                                    <CopyToClipboard text={text} onCopy={() => setOpen(false)}>
                                        <Button target="primary">
                                            Copiar licença
                                        </Button>
                                    </CopyToClipboard>
                                </>
                            }
                            <Button onClick={() => setOpen(false)}>
                                Fechar
                            </Button>
                        </div>
                    </DialogPanel>
                </div>
            </div>
        </Dialog>
    );
};

export default LicensesModal;